import { Pipe, PipeTransform } from '@angular/core';
import { castArray } from 'lodash';

@Pipe({
  name: 'castArray',
  standalone: true,
})
export class CastArrayPipe implements PipeTransform {
  public transform<T>(value: T | T[]): T[] {
    return castArray(value);
  }
}
